module.exports = __webpack_public_path__ + "static/novy-plugin-neon-nette-support-05d2a52fd69dd1c0378a623973b36bba.jpg";